export default "__VITE_ASSET__e99cce11__"